module.exports = __webpack_public_path__ + "img/eyes.0965278c.svg";